export default () => ({
  search: "",
  filters: [],
  openProducts: [],
  tableData: JSON.parse(document.getElementById('productsTable').dataset.table),
  filteredProducts: [],
  filesLists: {},
  init() {
    this.filterProducts()
  },
  productSearch: {
    ["x-on:keydown.debounce"]() {
      this.openProducts = [];
      this.filterProducts()
    },
    ["x-on:keydown.window.prevent.slash"]() {
      this.$refs.searchField.focus()
    },
    ["x-bind:class"]() {
      return this.search ? "active" : ""
    }
  },
  toggleFilter(id) {
    const isAlreadySelected = this.isSelectedFilter(id);
    if (isAlreadySelected) {
      this.filters = this.filters.filter(f => f !== id)
      this.filterProducts()
      return
    }
    this.filters.push(id);
    this.filterProducts()
  },
  isSelectedFilter(id) {
    return this.filters.some(f => f === id)
  },
  resetFilters() {
    this.filters = []
    this.filterProducts()
  },
  toggleOpenProduct(id) {
    const isAlreadySelected = this.isOpenProduct(id);
    if (isAlreadySelected) {
      this.openProducts = this.openProducts.filter(p => p !== id)
      this.filterProducts()
      return
    }
    this.openProducts.push(id);
    this.filterProducts()
  },
  isOpenProduct(id) {
    return this.openProducts.includes(id)
  },
  resetOpenProducts() {
    this.openProducts = []
  },

  filterProducts() {
    let products = [];

    if(this.search.length) {
      this.filteredProducts = this.filterByQuery()
      return
    }

    for (let [index, prod] of this.tableData.entries()) {
      const strategy = prod[0].strategy
      if(this.filters.includes(strategy) || !this.filters.length) {
        products.push(this.filterByOpenProducts(prod))
      }
    }

    this.filteredProducts = products
  },

  filterByQuery() {
    let filtered = []

    for (let [index, prod] of this.tableData.entries()) {
      const strategy = prod[0].strategy
      if(!this.filters.includes(strategy) && this.filters.length) continue

      if(prod.some(
        (prd) => prd.title.toLowerCase().includes(this.search.toLowerCase())
                || prd.isin.toLowerCase().includes(this.search.toLowerCase())
                || prd.wkn.toLowerCase().includes(this.search.toLowerCase())

      )) {
        filtered.push(prod)
        this.openProducts.push(prod[0].id)
      }
    }

    return filtered
  },
  filterByOpenProducts(products) {
    if(products.length === 1) products[0]['only'] = true

    if(!this.openProducts.includes(products[0].id)) {
      return [products[0]]
    }

    return products
  },
  highlight(text) {
    let searched = this.search.trim();
    if (searched === "") return text

    text = text.trim()

    let index = text.toLowerCase().indexOf(searched.toLowerCase());
    if (index >= 0) {
      return text.substring(0,index) + "<mark>" + text.substring(index,index+searched.length) + "</mark>" + text.substring(index + searched.length);
    }

    return text
  },
  clearSearch() {
    this.search = ""
    this.openProducts = []
    this.filterProducts()
  },
  getFilesList(uri) {
    const that = this
    if(this.filesLists[uri]) return
    fetch(uri+"/productdocumentssimple")
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.json();
        } else {
          this.hasError = true;
          throw Error(`${response.status} - ${response.statusText}`);
        }
      })
      .then(function (data) {
        that.filesLists[uri] = data
      })
      .catch((err) => {
        console.log(err);
      })
  }
})
